// Mark'n'Post flexible form — country whitelist and category mapping per ТЗ v0.2 §1.
export const PARCEL_COUNTRIES = [
    { code: "GE", category: "GEORGIA", phoneCode: "+995", nameRu: "Грузия" },
    // POST_SOVIET (не-Европа). RU/BY/KZ временно задизейблены — в разработке (brief v2).
    { code: "RU", category: "POST_SOVIET", phoneCode: "+7", nameRu: "Россия", disabled: true },
    { code: "BY", category: "POST_SOVIET", phoneCode: "+375", nameRu: "Беларусь", disabled: true },
    { code: "AM", category: "POST_SOVIET", phoneCode: "+374", nameRu: "Армения" },
    { code: "KZ", category: "POST_SOVIET", phoneCode: "+7", nameRu: "Казахстан", disabled: true },
    // EUROPE: UA, MD, TR + EU-27 + UK + Балканы + NO/CH/IS + Скандинавия и Прибалтика
    { code: "UA", category: "EUROPE", phoneCode: "+380", nameRu: "Украина" },
    { code: "MD", category: "EUROPE", phoneCode: "+373", nameRu: "Молдова" },
    { code: "TR", category: "EUROPE", phoneCode: "+90", nameRu: "Турция" },
    { code: "UK", category: "EUROPE", phoneCode: "+44", nameRu: "Великобритания" },
    { code: "DE", category: "EUROPE", phoneCode: "+49", nameRu: "Германия" },
    { code: "FR", category: "EUROPE", phoneCode: "+33", nameRu: "Франция" },
    { code: "IT", category: "EUROPE", phoneCode: "+39", nameRu: "Италия" },
    { code: "ES", category: "EUROPE", phoneCode: "+34", nameRu: "Испания" },
    { code: "PL", category: "EUROPE", phoneCode: "+48", nameRu: "Польша" },
    { code: "NL", category: "EUROPE", phoneCode: "+31", nameRu: "Нидерланды" },
    { code: "BE", category: "EUROPE", phoneCode: "+32", nameRu: "Бельгия" },
    { code: "AT", category: "EUROPE", phoneCode: "+43", nameRu: "Австрия" },
    { code: "PT", category: "EUROPE", phoneCode: "+351", nameRu: "Португалия" },
    { code: "IE", category: "EUROPE", phoneCode: "+353", nameRu: "Ирландия" },
    { code: "CZ", category: "EUROPE", phoneCode: "+420", nameRu: "Чехия" },
    { code: "SK", category: "EUROPE", phoneCode: "+421", nameRu: "Словакия" },
    { code: "HU", category: "EUROPE", phoneCode: "+36", nameRu: "Венгрия" },
    { code: "RO", category: "EUROPE", phoneCode: "+40", nameRu: "Румыния" },
    { code: "BG", category: "EUROPE", phoneCode: "+359", nameRu: "Болгария" },
    { code: "GR", category: "EUROPE", phoneCode: "+30", nameRu: "Греция" },
    { code: "HR", category: "EUROPE", phoneCode: "+385", nameRu: "Хорватия" },
    { code: "RS", category: "EUROPE", phoneCode: "+381", nameRu: "Сербия" },
    { code: "BA", category: "EUROPE", phoneCode: "+387", nameRu: "Босния и Герцеговина" },
    { code: "MK", category: "EUROPE", phoneCode: "+389", nameRu: "Северная Македония" },
    { code: "AL", category: "EUROPE", phoneCode: "+355", nameRu: "Албания" },
    { code: "ME", category: "EUROPE", phoneCode: "+382", nameRu: "Черногория" },
    { code: "XK", category: "EUROPE", phoneCode: "+383", nameRu: "Косово" },
    { code: "SI", category: "EUROPE", phoneCode: "+386", nameRu: "Словения" },
    { code: "NO", category: "EUROPE", phoneCode: "+47", nameRu: "Норвегия" },
    { code: "CH", category: "EUROPE", phoneCode: "+41", nameRu: "Швейцария" },
    { code: "IS", category: "EUROPE", phoneCode: "+354", nameRu: "Исландия" },
    { code: "SE", category: "EUROPE", phoneCode: "+46", nameRu: "Швеция" },
    { code: "FI", category: "EUROPE", phoneCode: "+358", nameRu: "Финляндия" },
    { code: "DK", category: "EUROPE", phoneCode: "+45", nameRu: "Дания" },
    { code: "EE", category: "EUROPE", phoneCode: "+372", nameRu: "Эстония" },
    { code: "LV", category: "EUROPE", phoneCode: "+371", nameRu: "Латвия" },
    { code: "LT", category: "EUROPE", phoneCode: "+370", nameRu: "Литва" },
    { code: "US", category: "NORTH_AMERICA", phoneCode: "+1", nameRu: "США" },
    { code: "CA", category: "NORTH_AMERICA", phoneCode: "+1", nameRu: "Канада" },
];
export const PARCEL_COUNTRY_BY_CODE = Object.fromEntries(PARCEL_COUNTRIES.map((c) => [c.code, c]));
export function isWhitelistedCountry(code) {
    return code in PARCEL_COUNTRY_BY_CODE;
}
export function getCountry(code) {
    return PARCEL_COUNTRY_BY_CODE[code];
}
export function getCategory(code) {
    return PARCEL_COUNTRY_BY_CODE[code]?.category;
}
// Q1 default: allow NORTH_AMERICA → POST_SOVIET. Flip this constant to disable.
const ALLOW_NA_TO_POST_SOVIET = true;
export function isDisabledCountry(code) {
    return PARCEL_COUNTRY_BY_CODE[code]?.disabled === true;
}
/**
 * Returns null if route is allowed; otherwise a structured rejection reason.
 * Used by both the Origin → Destination selector (filtering destinations) and
 * the form-level validator.
 */
export function rejectRoute(origin, destination) {
    const o = getCategory(origin);
    const d = getCategory(destination);
    if (!o || !d) {
        return {
            code: "not_whitelisted",
            message: "Эта страна не поддерживается в текущей версии сервиса.",
        };
    }
    if (isDisabledCountry(origin) || isDisabledCountry(destination)) {
        return {
            code: "country_disabled",
            message: "Это направление сейчас в разработке.",
        };
    }
    // Internal (origin = destination): allowed only for GE→GE and RU→RU.
    if (origin === destination && !(origin === "GE" || origin === "RU")) {
        return {
            code: "internal_not_allowed",
            message: "Внутристрановая доставка доступна только в Грузии и России.",
        };
    }
    if (!ALLOW_NA_TO_POST_SOVIET && o === "NORTH_AMERICA" && d === "POST_SOVIET") {
        return {
            code: "blocked_na_to_post_soviet",
            message: "Доставка из Северной Америки в эту страну временно недоступна.",
        };
    }
    return null;
}
export function allowedDestinations(origin) {
    return PARCEL_COUNTRIES.filter((c) => rejectRoute(origin, c.code) === null);
}
//# sourceMappingURL=countries.js.map